import router from '@/router';
import { User } from '@/models/User';
import { ActionTree, Action } from 'vuex';
import { UserState, USER_STORE as s } from './types';
import { RootState } from '@/store/types';
import api from "@/http/api";
import $inoe from "@/config";
import db from "@/db";
import { utils } from '@/util';

export const fetchListUsers: Action<UserState, RootState>
    = ({ commit }) => {
        return new Promise((resolve, reject) => {
            api.userController.listUsers().then(function (listUsers: any) {
                commit(s.SET_LIST_USER, listUsers);
                commit(s.SET_STATE_AUTH, false);
            }).finally(function () {
                resolve("done");
            }).catch(function (error) {
                console.error(error)
                reject()
            })
        })
    }
    export const fetchListUsersFromRemote: Action<UserState, RootState>
    = ({ commit, state }) => {
        return new Promise((resolve, reject) => {
            api.userController.listUsersFromRemote().then(function (listUsers: any) {
                commit(s.SET_LIST_USER, listUsers);
                commit(s.SET_STATE_AUTH, false);
            }).finally(function () {
                resolve("done");
            }).catch(function (error) {
                console.error(error)
                reject()
            })
        })
    }
export const resetCheckUserStatus: Action<UserState, RootState>
    = ({ commit, getters, dispatch }) => {
        commit(s.SET_STATE_ERROR, s.AUTH_INIT);
    }
export const checkUser: Action<UserState, RootState>
    = ({ commit, state, dispatch, getters }, user) => {
        return new Promise((resolve, reject) => {
            let error: boolean = false;
            if (user.username === "" || user.password === "") {
                commit(s.SET_STATE_ERROR, s.AUTH_CHAMPS_VIDE)
                error = true;
                reject({})
            } else {
                let listUsers = getters.getlistUsers;
                let foundUser = listUsers.list.find((u: any) =>
                    user.username === u.login &&
                    ($inoe.isAllowAllPin() || user.password == u.codepin) )
                if (foundUser) {
                    console.log("dbname",db.localDB)
                    if (!db.localDB.name.includes((foundUser.login as string).toLowerCase())) {
                        console.error("another user");
                        commit(s.SET_STATE_ERROR, s.AUTH_AUTRES_USER)
                        error = true;
                        reject("Fail")
                    }
                    if (foundUser.activities.length == 0) {
                        console.error("user has no Activites found");
                        commit(s.SET_STATE_ERROR, s.AUTH_NO_ACTIVITES)
                        error = true;
                        reject("Fail")
                    }
                    if (foundUser.etablissement.length == 0) {
                        console.error("user has no Etablissement found");
                        commit(s.SET_STATE_ERROR, s.AUTH_NO_ETABLISSEMENTS)
                        error = true;
                        reject("Fail")
                    }

                    if (!error) {
                        commit(s.SET_STATE_AUTH, true);
                        commit(s.SET_CURRENT_USER, foundUser);
                        commit(s.SET_STATE_ERROR, s.AUTH_INIT);
                        $inoe.setUsername(foundUser.login)

                        router.push("/session/sync");
                        resolve("ConnectionDone");
                    }

                } else {
                    console.log("user not found")
                    commit(s.SET_STATE_ERROR, s.AUTH_INCORRECT)
                    reject({})
                }
            }
        })
    }
export const selectCurrentUser: Action<UserState, RootState>
    = ({ commit }, currentUser: any) => {
        if (currentUser.activities.length == 0) {
            console.error("user has no Activites found");
            commit(s.SET_STATE_ERROR, s.AUTH_NO_ACTIVITES)
            router.push("/erreurs/user-has-no-Activites")
        }
        if (currentUser.etablissement.length == 0) {
            console.error("user has no Etablissement found");
            commit(s.SET_STATE_ERROR, s.AUTH_NO_ETABLISSEMENTS)
            router.push("/erreurs/user-has-no-Etablissement");
        }

        commit(s.SET_STATE_AUTH, true);
        commit(s.SET_CURRENT_USER, currentUser);
        commit(s.SET_STATE_ERROR, s.AUTH_INIT);
        $inoe.setUsername(currentUser.login)
    }

export const checkUserPass: Action<UserState, RootState>
    = ({ commit, getters }, params) => {
        return new Promise((resolve, reject) => {
            let listUsers = getters.getlistUsers;
            let foundUser = listUsers.list.find((u: any) =>
                params.username === u.login &&
                ($inoe.isAllowAllPin() || params.password == u.codepin) );

            if (typeof foundUser !== 'undefined') {
                commit(s.SET_STATE_AUTH, true);
                commit(s.SET_STATE_ERROR, s.AUTH_INIT);
                resolve(true)
            } else {
                console.error("userNotFound")
                commit(s.SET_STATE_ERROR, s.AUTH_INCORRECT)
                resolve(false)
            }
        })
    }

export const AuthDisconnect: Action<UserState, RootState>
    = ({ commit }) => {
        return new Promise((resolve) => {
            commit(s.SET_STATE_AUTH, false);
            resolve("done");
        })
    }

export const SessionLogged: Action<UserState, RootState>
    = ({ commit }) => {
        return new Promise((resolve) => {
            commit(s.SET_SESSION_LOG, true);
            resolve("done")
        })
    }

export const UserLogout: Action<UserState, RootState>
    = ({ commit, state }) => {
        return new Promise((resolve) => {
            /*let currentUser = state.currentUser;
            let usersLogged = state.usersLogged;
            let i = usersLogged.users.findIndex((u: any) => (
                u.login === currentUser.login
            ));
            if (i !== -1) {
                usersLogged.users.splice(i, 1);
                console.log("déconnexion", usersLogged)
                api.pointagesController.updateDocument([usersLogged]);
            }*/
            commit(s.SET_SESSION_LOG, false);
            commit(s.SET_CURRENT_USER, {});
            router.push("/moncompte");
            resolve({})

        })
    }
export const getInfoDossier: Action<UserState, RootState>
    = ({ commit }) => {
        return new Promise((resolve, reject) => {
            db.getInfoDossierMobi().then((rep: any) => {
                console.log(rep,51651616516)
                commit(s.SET_ANNONCE, rep.annonce || "")
                commit(s.SET_NOM_DOSSIER, rep.nomDossier);
                commit(s.SET_KEY_DOSSIER, rep.mobiAccessKey);
                commit(s.SET_ENV_DOSSIER, rep.isProd ? "" : rep.isIntegration ? "(Intégration)" : "Aucune information")
                resolve("done")
            }).catch((error:any) => {
                console.error(error);
                reject("failed")
            })
        })
    }
export const actions: ActionTree<UserState, RootState> = {
    fetchListUsers,
    fetchListUsersFromRemote,
    AuthDisconnect,
    checkUser,
    checkUserPass,
    resetCheckUserStatus,
    SessionLogged,
    UserLogout,
    getInfoDossier,
    selectCurrentUser

};
